module.exports = __webpack_public_path__ + "img/user_icon.a8df4e35.png";